import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DocumentStatusInfoContent } from './DocumentStatusInfoContent';

export interface IDocumentStatusInfoProps {
}

const queryClient = new QueryClient();

export const DocumentStatusInfo = (props: IDocumentStatusInfoProps): React.ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <DocumentStatusInfoContent/>
    </QueryClientProvider>
  );
}